import { render } from "./LibrosFiscalesPage.vue?vue&type=template&id=73efe2cd&scoped=true"
import script from "./LibrosFiscalesPage.vue?vue&type=script&lang=js"
export * from "./LibrosFiscalesPage.vue?vue&type=script&lang=js"

import "./LibrosFiscalesPage.vue?vue&type=style&index=0&id=73efe2cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73efe2cd"]])

export default __exports__